import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02865b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper shadowboxing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-label ibf-h2 mb-[24px]" }, "License Details", -1))
const _hoisted_3 = { class: "license-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Registered To", -1))
const _hoisted_5 = { class: "details" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Expiration Date", -1))
const _hoisted_7 = { class: "details" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Maintenance Date", -1))
const _hoisted_9 = { class: "details" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dateUtils } from '@/services/dateUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'licenseInfo.linux',
  props: {
    licenseInfo: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "flex flex-col h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.licenseInfo?.linux?.licenseName), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(dateUtils).getFormattedDate(__props.licenseInfo?.expirationInfo?.expirationDate)), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(dateUtils).getFormattedDate(__props.licenseInfo?.expirationInfo?.expirationDate)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})